class NovaProductCardAsync extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const productHandle = this.dataset.handle
    this.loadProductCard = this.loadProductCard.bind(this)

    this.loadProductCard(productHandle)
  }

  loadProductCard(productHandle) {
    fetch(`/products/${productHandle}?view=card`)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html')
        this.innerHTML = html.querySelector('.product-view-card').innerHTML

        const card = this.querySelector('nova-product-card')

        const swatchesTemplate = this.querySelector(
          `#async-swatches-json-${card.id}`,
        )
        const colorValuesTemplate = this.querySelector(
          `#async-color-values-json-${card.id}`,
        )
        const sizesTemplate = this.querySelector(
          `#async-sizes-json-${card.id}`,
        )
        const variantsTemplate = this.querySelector(
          `#async-variants-json-${card.id}`,
        )
        const imagesTemplate = this.querySelector(
          `#async-images-json-${card.id}`,
        )

        const swatches = swatchesTemplate
          ? JSON.parse(swatchesTemplate.content.textContent.trim())
          : []
        const colorValues = colorValuesTemplate
          ? JSON.parse(colorValuesTemplate.content.textContent.trim())
            : []
        const sizes = sizesTemplate
          ? JSON.parse(sizesTemplate.content.textContent.trim())
          : []
        const variants = variantsTemplate
          ? JSON.parse(variantsTemplate.content.textContent.trim())
          : []
        const images = imagesTemplate
          ? JSON.parse(imagesTemplate.content.textContent.trim())
          : []

        card.swatches = swatches
        card.colorValues = colorValues
        card.sizes = sizes
        card.variants = variants
        card.images = images
      })
  }
}

customElements.define('nova-product-card-async', NovaProductCardAsync)
